const WithOrWithoutYou = [
	'[Verse 1]',
	'See the stone set in your eyes',
	'See the thorn twist in your side',
	'I wait for you',
	'Sleight of hand and twist of fate',
	'On a bed of nails she makes me wait',
	'And I wait, without you',
	'',
	'[Chorus]',
	'With or without you',
	'With or without you',
	'',
	'[Verse 2]',
	'Through the storm we reach the shore',
	'You give it all but I want more',
	'And I’m waiting for you',
	'',
	'[Chorus]',
	'With or without you',
	'With or without you ahah',
	'I can’t live',
	'With or without you',
	'',
	'[Bridge]',
	'And you give yourself away',
	'And you give yourself away',
	'And you give',
	'And you give',
	'And you give yourself away',
	'',
	'[Verse 3]',
	'My hands are tied',
	'My body bruised, she got me with',
	'Nothing to win and',
	'Nothing left to lose',
	'',
	'[Bridge]',
	'And you give yourself away',
	'And you give yourself away',
	'And you give',
	'And you give',
	'And you give yourself away',
	'',
	'[Chorus]',
	'With or without you',
	'With or without you oh-oh',
	'I can’t live',
	'With or without you',
	'',
	'[Interlude]',
	'Oh-oh-oh-oh',
	'Oh-oh-oh-oh-oh',
	'Oh-oh-oh-oh',
	'Oh-oh-oh',
	'',
	'[Chorus]',
	'With or without you',
	'With or without you ahah',
	'I can’t live',
	'With or without you',
	'With or without you',
];

export default WithOrWithoutYou;
